export default {
    top_menu: [
        {name:'หลัก',    id:0},
        {name:'แสดงธุรกิจ', id:1},
        {name:'การทำอาหาร',  id:2},
        {name:'นโยบาย',   id:3},
        {name:'+18',  id:4},
        {name:'สังคม',   id:5},
        {name:'สุขภาพ',   id:6},
    ],
    read_other: 'อ่านเพิ่มเติม',
    read_more:  'รายละเอียด',
    not_found:  'ไม่พบสิ่งใด',
    read_also:  'อ่านด้วย',
    copy_rights: 'ลิขสิทธิ์© 2019 Mixer-novostei.ru สงวนลิขสิทธิ์',
    subscribe: 'สมัครสมาชิก',
    thank_order: 'ขอบคุณสำหรับคำสั่งซื้อ',
    specialist_contact: 'ผู้เชี่ยวชาญของเราจะติดต่อคุณในไม่ช้าคาดหวังว่าจะมีการโทรของเรา',
    attention: 'ส่วนลดจากพันธมิตร:',
    hurry: 'รีบหน่อยเวลาเปิดใช้งานส่วนลดมี จำกัด ! คุณมี <span id = "time" class = "time"> 30:00 </span> นาทีเพื่อเลือกหนึ่งในผลิตภัณฑ์ที่ไม่ซ้ำกันเหล่านี้:',
    hour_ago1: "ชั่วโมงที่แล้ว",
    hour_ago2: "ชั่วโมงที่แล้ว",
    hour_ago3: "ชั่วโมงที่แล้ว",
    new_publications: "โพสต์ใหม",
    read: "อ่านแล้ว",
    today_at: "วันนี้ใน",
    author_names: ['Bird Thongchai','Tony Jaa','Tata Young'],
    main_news: "ข่าวติดอันดับ",
    leave_already: "กำลังจะออกไปแล้วเหรอ โปรดรอข่าวสารที่เราได้ทำการอัพเดทก่อน",
    already_shared: "แชร์แล้ว"
}